import { render, staticRenderFns } from "./UploadingParameter.vue?vue&type=template&id=8e4fe122"
import script from "./UploadingParameter.vue?vue&type=script&lang=js"
export * from "./UploadingParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports